import { Typography, Box } from "@mui/material"
import DiseaseCode from "../../shared/DiseaseCode"

const DiseaseItem = (props) => {
  const { item } = props

  return (
    <Box sx={{ display: "flex", mt: 1 }}>
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            mb: 1,
          }}
        >
          <Typography variant="body2">{item.disease.name}</Typography>

          <DiseaseCode icd10={item.disease.icd10} />
        </Box>
      </Box>
    </Box>
  )
}

export default DiseaseItem
